import React from 'react';
import {Space} from 'antd';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {
  StyledDocumentUploadRules,
  StyledDocumentUploadRulesList,
  StyledDocumentUploadRulesListItem
} from './StyledDocumentUploadRules';
import IconWrapper from '../../../../../IconWrapper';
import {CheckIcon, CloseIcon} from '../../../../../../icons';
import theme from '../../../../../../theme';

const DocumentUploadRules = ({
  rules = [],
  ...rest
}) => {
  const [t] = useTranslation(['main', 'quickStart']);

  const trans = (key) => t(`quickStart:kyc.${key}`);

  return (
    <StyledDocumentUploadRules
      direction='vertical'
      size='large'
      {...rest}
    >
      {rules.length && (
        <StyledDocumentUploadRulesList>
          {rules.map(({label, variant, ...rest}, key) => (
            <StyledDocumentUploadRulesListItem
              key={key}
              variant={variant}
              {...rest}
            >
              <Space size='middle'>
                <IconWrapper size={24} color={variant === 'success' ? theme.colors.functional_success : theme.colors.functional_danger}>
                  {variant === 'success' ? <CheckIcon /> : <CloseIcon />}
                </IconWrapper>
                {label}
              </Space>
            </StyledDocumentUploadRulesListItem>
          ))}
        </StyledDocumentUploadRulesList>
      )}
      <p>
        {trans('maxFileSize')}<br/>{trans('supportedFormats')}
      </p>
    </StyledDocumentUploadRules>
  );
}

DocumentUploadRules.propTypes = {
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      variant: PropTypes.oneOf(['error', 'success'])
    })
  )
}

export default DocumentUploadRules;
